import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as actions from '../../store/actions';
import { withRouter } from 'react-router';
import Wrp from "../../hoc/Wrp/Wrp";
import BreadCrumbs from "../../Components/UI/BreadCrumbs";
import { callGET,callPOST,callDELETE,callAPIUsingName } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';
import TableRecord from "../../Components/UI/TableRecord";
import Icons from '../../Components/Icons/Icons';
import {getWindowDataUsingId} from '../../Utils/CommonFunctions';
import CreateNew from './CreateNew';

class TaxDetailsContainer extends Component {
  state = {
    isModalOpen:false,
    name:'',
    id:null,
    error:'',
    violations:{},
    tableRecords:{
        tableHead:[
          {
              name:"Action",
              type:"Actions",
              href:"",
              isShow:true,
              clickHandler:"",
              attributes:{
                style:{width: "75px"}
              }
          },
          {
            name:"Tag Name",
            type:"Setting",
            clickHandler:"",
            isShow:true,
            attributes:{
              style:{width: "200px"}
            }
          },
          {
            name:"Windows",
            type:"Text",
            isShow:true,
          }
        ],
        tableData:[], 
        pagination:{
          page:0,
          orderBy:'tag_name',
          perPage:10,
          direction:'DESC',
          totalRecords:0,
          search:''
        }
      },
      isEdit:false,
  }

  componentWillMount() {
    this.tagList(this.state.tableRecords.pagination);
  }

  selectTagsHandler = (val) => {
    const tagsData = val;
    console.log(val);
    this.props.globalSearch(JSON.stringify(val));
    let url = "";
    if(tagsData.windows) {
      if(tagsData.windows.length>0) {
        const wind = tagsData.windows[0];
        const data = getWindowDataUsingId(wind.id);
        
        url = "/layouts/"+wind.display_name+"/"+wind.id+"/list/"+data.layout_id+'/tags/'+tagsData.id;
      }
    }
    console.log(url);
    if(url !== '')
      this.props.history.push(url);
  }

  tagList = (pagination) => {
    this.props.Loader();
      const page = pagination.page; 
      const orderBy = pagination.orderBy; 
      const perPage = pagination.perPage; 
      const direction = pagination.direction; 
      const search = pagination.search;
      this.setState({
        tableRecords:{
          ...this.state.tableRecords,
          pagination:pagination
        }
      });
      // const API_URL = "tag-mapping/search-tags?searchKeyword="+data.searchText+"&paginator.orderBy=tag_name&paginator.sortAsc=true&paginator.page=0&paginator.size=30";
      const url = "tag-mapping/search-tags";
      const queryString = '?searchKeyword='+search+'&paginator.page='+page+'&paginator.orderBy='+orderBy+'&paginator.size='+perPage+'&paginator.sortAsc=true';
      callGET(url+queryString)
      .then(response => {
        console.log(response);
        this.props.Loader(false);
        const responseData = response.data;
        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) { 
          console.log(responseData.data);
          if(responseData.data && responseData.data.content){
            let updateTableData = responseData.data.content.map((item,index)=>{
              let windowsList =  '';
              if(item.windows) {
                item.windows.map((arr,ind) => {
                  windowsList += ind === 0 ? arr.display_name : ', '+arr.display_name
                })  
              }
              
                return {
                  className:'icon_hover cursor-pointer',
                  rowId:item.id,
                  data:{
                    actions:[
                        {
                          clickHandler:this.editHandler.bind(this,item),
                          attributes:{
                            className:windowsList !== "" ? "hide" : "p-1"
                            },
                            svgIcon:"Edit",
                          //iconClass:"fas fa-pencil-alt third_dark_color",
                          name:""
                        },
                        {
                          attributes:{
                            className:windowsList !== "" ? "hide" : "p-1"
                          },
                          svgIcon:"Delete",
                          clickHandler:this.deleteHandler.bind(this,item.id),
                          name:""
                        } 
                        
                    ],
                    name: {
                        value: item.tag_name,
                        clickHandler:this.selectTagsHandler.bind(this,item),
                        param:{
                          data:{...item},
                        },
                        
                        attributes:{
                          className:"text-truncate",
                          id: item.id
                          // is_editable: item.is_editable.toString(),
                        },
                        setting:{}
                      },  
                    windows:windowsList
                }
              }
            });
            const totalRecords = responseData.data.total_elements;
            
            this.setState({status:200,tableRecords:{
                tableData:{data:updateTableData,status:200},
                tableHead:this.state.tableRecords.tableHead ,
                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});
            // console.log(this.state.tableRecords);
        }else{
            const totalRecords = 0;//response.data.totalElements;
            this.setState({status:200,tableRecords:{
                tableData:[],
                tableHead:this.state.tableRecords.tableHead ,
                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});    
        }
      }else{
          // this.props.Loader();
          this.props.failMessage(responseData.message);   
          const totalRecords = 0;//response.data.totalElements;
            this.setState({status:200,tableRecords:{
                tableData:[],
                tableHead:this.state.tableRecords.tableHead ,
                pagination:{...this.state.tableRecords.pagination,totalRecords:totalRecords}
            }});    
      }
      })
      .catch(err => {
        this.props.Loader(false);
          console.log("Connction Error============",err);
      });
    }


  deleteHandler = (ide) => {
    // console.log("ide",ide);
    // let isDelete = window.confirm("are you sure you want to delete this data?");
    // if(isDelete) {
      this.props.Loader();
      callDELETE("tag/"+ide)
      .then(response => {
        this.props.Loader();
            console.log(response);
            const responseData = response.data;
            if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
              this.props.succMessage(responseData.message);
              this.tagList(this.state.tableRecords.pagination);
            }else {
              this.props.failMessage(responseData.message);
            }
      })
      .catch(err => {
            this.props.Loader();
            this.props.failMessage("Error occured");
            console.log(err);
          })
    // }
  }

  editHandler = (item) => {
    this.setState({isModalOpen:true,name:item.tag_name,id:item.id, isEdit:true});
  }

  createTagToggle = () => {
  this.setState({
    isModalOpen: !this.state.isModalOpen,
    name: "",
    id: null,
    isEdit: false,
    error: ''   
  });
}

  createTagChangeHandler = (e) => {
  const {name,value} = e.target;
  this.setState({
    [name]: value,
    error: ''  
  });
}

  saveTagDetails = () => {
//     if (!this.state.name || this.state.name.trim() === '') {
//   this.setState({ error: 'Tag name is required' });
//   return;
// }

// if (this.state.name.length > 50) {
//   this.setState({ error: 'Tag name must not exceed 50 characters' });
//   return;
// }
    this.props.Loader();
    let body = {
      tag_name:this.state.name
    };

    let API_URL = "";
    let method = "post";
    if(this.state.id && this.state.id!== '') {
      API_URL = "tag/update";
      body.id=this.state.id;
      method = "put";
    }else {
      API_URL = "tag/create";
      method = "post";
    }
    callAPIUsingName(method,API_URL,body)
        .then(response => {
          this.props.Loader();
          const responseData = response.data;
          if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
            this.props.succMessage(responseData.message);
            this.createTagToggle();
            this.tagList(this.state.tableRecords.pagination);
            this.setState({isEdit:false});
          }else {
            let viol = {};
            let errMsg = '';
            if(responseData.violations) {
              responseData.violations.map((arr,ind) => {
                const data = arr.field_name+':'+arr.message;
                viol[arr['field_name']]= arr['message'];
                errMsg += ind === 0 ? data : '<br />'+data;
                console.log(errMsg);
                
              })
              this.setState({violations:viol});
            }
            console.log(responseData.message,errMsg);
            let finalError = '';

if (responseData.violations && responseData.violations.length > 0) {
  finalError = responseData.violations
    .map(v => v.message)
    .join(', ');
} else if (responseData.message && responseData.message !== 'Bad Request') {
  finalError = responseData.message;
}

this.setState({ error: finalError });
            // this.props.failMessage(responseData.message+"<br/>"+errMsg);
          }
        })
        .catch(err => {
          this.props.Loader();
          this.props.failMessage("Error occured");
          console.log(err);
        })
  }

  render () {
      const breadCrumbs =  {
          backHistory : [{
          href : "/settings",
          name:"Settings"
          }],
          pageTitle:"Tag",
          buttonList:[{
            href:"",
            clickHandler:this.createTagToggle,
            name: "Add New",
            svgIcon:"AddPlus",
            attributes:{
              className:"btn primary_bg mr-2 "
            },
            type:"addnew",
            icon:"",
          }]
      }

      // console.log(this.state.tableRecords.pagination.totalRecords);

    return(
      <Wrp>
        <BreadCrumbs breadCrumbsList={breadCrumbs} />
        <div className="viewport">
          <div className="view view-xl">
            <div className="outerPort">
               
              <TableRecord 
                  tableRecords={this.state.tableRecords} 
                  recordsChangeHandler={this.tagList}
                />

              <CreateNew
                toggleModel={this.createTagToggle}
                curState = {this.state}
                  error={this.state.error}
                createTagChangeHandler={this.createTagChangeHandler}
                saveTagDetails={this.saveTagDetails}
              />
              
            </div>
          </div>
        </div>
      </Wrp>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticated: state,
    selectedWindowData:state.reducer.selectedWindowData,
  };
}

const mapDispatchToProps = dispatch => {
  return {
    Loader : () => dispatch(actions.loader()),
    succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg)),
    globalSearch:(val) => dispatch({type : 'SET_SELECTED_TAGS',value:val})
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(TaxDetailsContainer));